<template>
    <div>
      <b-row class="d-flex justify-content-between">
        <b-col cols="6" class="mb-4">
          <b-card title="NC">
            <b-table stacked :items="items.NC"></b-table>
          </b-card>
        </b-col>
        <b-col cols="6" class="mb-4">
          <b-card title="NP">
            <b-table stacked :items="items.NP"></b-table>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </template>

<script>
import {
    BCard,
    BRow,
    BCol,
    BTable,
} from "bootstrap-vue";

export default {
    components: {
        BCard,
        BRow,
        BCol,
        BTable,
    },
    props: {
        datarda: {
            type: Object,
            default: () => { },
            required: false
        }
    },
    data() {
        return {
            items: [],
        };
    },
    watch: {
        datarda() {
            if (this.datarda && this.datarda.REFERENCES) {
                this.items = {
                    NC: [],
                    NP: [],
                };
                
                // Procesar NC dinámicamente
                if (Array.isArray(this.datarda.REFERENCES.NC) && this.datarda.REFERENCES.NC.length > 0) {
                    const ncObject = {};
                    this.datarda.REFERENCES.NC.forEach((item) => {
                        if (item && item.references) {
                            const [key, value] = item.references.split(':');
                            if (key) {
                                ncObject[key.trim()] = value ? value.trim() : '0';
                            }
                        }
                    });
                    if (Object.keys(ncObject).length > 0) {
                        this.items.NC.push(ncObject);
                    }
                }
                
                // Procesar NP dinámicamente
                if (Array.isArray(this.datarda.REFERENCES.NP) && this.datarda.REFERENCES.NP.length > 0) {
                    const npObject = {};
                    this.datarda.REFERENCES.NP.forEach((item) => {
                        if (item && item.references) {
                            const [key, value] = item.references.split(':');
                            if (key) {
                                npObject[key.trim()] = value ? value.trim() : '0';
                            }
                        }
                    });
                    if (Object.keys(npObject).length > 0) {
                        this.items.NP.push(npObject);
                    }
                }
            }
        }
    },
    methods: {},
};
</script>

<style scoped lang="scss"></style>
